module.exports = __webpack_public_path__ + "img/ticket_status01.fa18bdaf.png";